import React from 'react'
import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

const RoundTickIcon = () => {
  return (
    <Svg width="60" height="60" fill="none">
      <G clipPath="url(#a)">
        <Path
          d="M26.555 39.42c.5.004.98-.185 1.344-.528l13.735-13.125h.001a1.922 1.922 0 0 0-2.642-2.788l-.002.002-12.436 11.852-5.545-5.29a1.922 1.922 0 1 0-2.643 2.788l6.866 6.56v.001a1.853 1.853 0 0 0 1.322.529Zm0 0v-.046.047ZM16.484 9.77c4-2.672 8.704-4.1 13.516-4.1A24.375 24.375 0 0 1 54.328 30 24.328 24.328 0 1 1 16.484 9.77Z"
          fill="#0E7A41"
          stroke="#0E7A41"
          strokeWidth=".094"
        />
      </G>
      <Defs>
        <ClipPath id="a">
          <Path fill="#fff" d="M0 0h60v60H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default RoundTickIcon
